<template>
  <span v-if="workingReward">
    <v-row class="mt-8">
      <v-col cols="12">
        <v-select label="Per POS Transaction Type" outlined dense :items="Object.entries(DebitPosTransactionTypes)" v-model="workingReward.posTransactionType"
          item-text="[1].description" item-value="[1].value" :rules="requiredRule" @change="onChange" ref="posTransactionType"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          label="Per POS Transaction Reduction Amount"
          v-model="workingReward.perPosTrxTypeFeeReductionAmount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="perPosTrxTypeFeeReductionAmount"
        />
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12">
        <v-text-field
          label="Minimum Transaction Amount"
          v-model="workingReward.minimumTrxAmount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="minimumTrxAmount"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { PerPosTrxTypeFeeReductionReward } from '@/api/product/levelrewards/rewards';
import { DebitPosTransactionTypes } from '@/api/product/levelrewards';
import { ValidationTool } from '@/util';

@Component
export default class PerPosTrxTypeFeeReductionRewardEditor extends Vue {
  @Prop()
  value!:PerPosTrxTypeFeeReductionReward;

  workingReward:PerPosTrxTypeFeeReductionReward | null = null;

  // Make available to template
  DebitPosTransactionTypes:any = DebitPosTransactionTypes;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as PerPosTrxTypeFeeReductionReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
</script>

<style lang="scss" scoped>
</style>
